<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  watch: {
    $route: {
      handler: function (val, oldval) {
        document.title = val.meta.title;
      }
    }
  }
}
</script>

<style>
@font-face {
  font-family: 'erYa';
  src:url("./utils/尔雅嘿嘿黑.ttf") format('truetype');
}
@font-face {
  font-family: 'Barlow-Black';
  src: url('./utils/Barlow-Black.ttf') format('truetype');
}

* {
  padding: 0;
  margin: 0;
}

body,
html,
#app {
  width: 100%;
  height: 100%;
}

div {
  box-sizing: border-box;
}

input,
textarea {
  outline: none;
}

.se_option .el-scrollbar__view {
  padding: 5px 0;
  background: rgba(0, 0, 0, 1);
}

.se_option .el-select-dropdown__item {
  color: #888;
  font-size: 20px;
}

.se_option .el-select-dropdown__item.hover {
  color: white;
  background: transparent;
}

.se_option .el-select-dropdown__item.selected {
  color: white;
  background: transparent;
}

.se_option .el-scrollbar__thumb {
  background: white;
}

.prop_se .el-scrollbar__view {
  padding: 0;
}
.prop_se .el-select-dropdown__item {
  color: white;
  font-size: 20px;
  background: url('./assets/bbImg/accout/prop/noHover.png') no-repeat;
}
.prop_se .el-select-dropdown__item.hover {
  color: white;
  background: url('./assets/bbImg/accout/prop/hover.png') no-repeat;
}
</style>



// WEBPACK FOOTER //
// src/App.vue